<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">系统</Breadcrumb-item>
        <Breadcrumb-item>短信发送</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <i-form ref="form" :model="formData" :rules="formRule" :label-width="80" class="form">
      <Form-item label="手机号" prop="phones">
        <Input type="textarea" :rows="4" v-model="formData.phones"/>
      </Form-item>
      <Form-item label="短信内容" prop="content">
        <Input type="textarea" :rows="4" v-model="formData.content"/>
      </Form-item>

      <Form-item>
        <i-button type="primary" @click="handleSubmit('formData')">提交</i-button>
      </Form-item>
    </i-form>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        readonly: false,
        defaultIcon: [],
        iconFile: [],
        formData: {
          phones: '',
          content: ''
        },
        formRule: {
          phones: [
            {required: true, message: '手机号不能为空', trigger: 'blur'}
          ],
          content: [
            {required: true, message: '内容不能为空', trigger: 'blur'}
          ]
        }
      }
    },
    created () {
      this.formData.id = this.$route.query.id
      this.readonly = this.$helper.isDetail(this.$route.path)
      let self = this

      // 有id 表示为编辑
      if (!this.formData.id || this.formData.id === '') {
        return
      }
      this.$http.get('/module/' + this.formData.id).then(function (response) {
        if (!response || !response.data) {
          return
        }
        let data = response.data
        self.$helper.copyProperties(data, self.formData)

        if (data.iconFile) {
          self.defaultIcon.push(data.iconFile)
        }
      })
    },
    mounted () {
    },
    methods: {
      handleSubmit (name) {
        let self = this
        this.$refs.form.validate((valid) => {
          if (valid) {
            let path = '/module/update'
            if (!this.formData.id || this.formData.id === '') {
              path = '/module/insert'
            }
            self.$http.post(path, self.formData).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('提交成功!')
                self.$router.push('/module')
              }
            })
          } else {
            self.$Message.warning('表单验证失败!')
          }
        })
      },
      back () {
        this.$router.push('/module')
      },
      handleReset (name) {
        this.$refs.form.resetFields()
      },
      handleIconChange (fileList) {
        this.formData.iconFileId = fileList.map(item => item.fileId).join(',')
      }
    },
    watch: {}
  }
</script>



// WEBPACK FOOTER //
// SendSms.vue?cdef3876